import React, {useEffect, useRef} from 'react';
import {inject, observer} from "mobx-react";

const ChatBaseBalloon = inject('rootstore')(observer((props) => {
  const isInitializedRef = useRef(false);
  const showChatRef = useRef(false);
  const previousTokenRef = useRef(null);

  useEffect(() => {
    showChatRef.current = ((props.rootstore.dataAutorizzazioni || {}).metron_chatbot || {}).abilitato || props.rootstore.userInfo.isCapoArea;
    const shouldExecute = props.rootstore.userToken && showChatRef.current;
    const currentToken = props.rootstore.userToken;

    const hideChatBase = () => {
      // console.log('>>> HIDE - ALL');
      showChatRef.current = false;

      const chatbaseButtom = document.getElementById('chatbase-bubble-button');
      if (chatbaseButtom) {
        chatbaseButtom.style.display = 'none';
        chatbaseButtom.style.visibility = 'hidden';
        chatbaseButtom.style.opacity = '0';
      }

      const chatbaseWindow = document.querySelectorAll([
        '#chatbase-bubble-window',
        // '#chatbase-bubble-window iframe'
      ].join(','));

      chatbaseWindow.forEach(el => {
        el.style.display = 'none';
      });

    };

    const showChatBase = () => {
      // console.log('>>> SHOW - BUTTON ONLY');

      const chatbaseButtom = document.getElementById('chatbase-bubble-button');
      if (chatbaseButtom) {
        chatbaseButtom.style.display = 'block';
        chatbaseButtom.style.visibility = 'visible';
        chatbaseButtom.style.opacity = '1';
      }

    };

    const initializeChatBase = () => {
      // console.log('>>> INIT');
      if (!isInitializedRef.current) {

        const script = document.createElement('script');
        script.innerHTML = `
          (function(){if(!window.chatbase||window.chatbase("getState")!=="initialized"){window.chatbase=(...arguments)=>{if(!window.chatbase.q){window.chatbase.q=[]}window.chatbase.q.push(arguments)};window.chatbase=new Proxy(window.chatbase,{get(target,prop){if(prop==="q"){return target.q}return(...args)=>target(prop,...args)}})}const onLoad=function(){const script=document.createElement("script");script.src="https://www.chatbase.co/embed.min.js";script.id="PvCwoW7FUBA4ObfGbDFfx";script.domain="www.chatbase.co";document.body.appendChild(script)};if(document.readyState==="complete"){onLoad()}else{window.addEventListener("load",onLoad)}})();
        `;
        script.type = 'text/javascript';
        document.body.appendChild(script);

        isInitializedRef.current = true;
        previousTokenRef.current = currentToken;
      }
    };

    if (shouldExecute) {
      if (!isInitializedRef.current) {
        initializeChatBase();
      }
      showChatBase();
    } else {
      if (isInitializedRef.current && previousTokenRef.current !== null) {
        hideChatBase();
      }
      previousTokenRef.current = null;
    }

    return () => {
      if (isInitializedRef.current) {
        hideChatBase();
      }
    };

  }, [
            props.rootstore.userToken,
            props.rootstore.dataAutorizzazioni,
            props.rootstore.userInfo.isCapoArea
  ]);

  return null;

}));

export default ChatBaseBalloon;
